import { useUserSelections } from '@components/service-and-repair/providers/user-selections';
import { useEffect, useState } from 'react';
import { daysSince } from '../../utilities';

export enum MileageError {
  TOO_LOW = 'TOO_LOW',
  TOO_HIGH = 'TOO_HIGH',
  UNKNOWN = 'UNKNOWN_ERROR',
}

export const useMileage = () => {
  const [savedMileage, setSavedMileage] = useState<string | null>(null);
  const { userFeedData } = useUserSelections();
  const { mileage: saleMileage, saleEffectiveDate, vehicleId } = userFeedData;
  const mileageKey = `CV${vehicleId}Mileage`;

  const getMileageFromStorage = () => {
    const mileage = sessionStorage.getItem(mileageKey);

    if (mileage) {
      setSavedMileage(mileage);
    }
  };

  const saveMileage = (mileage: number) => {
    setSavedMileage(mileage.toString());
    sessionStorage.setItem(mileageKey, mileage.toString());
  };

  const deleteSavedMileage = () => {
    sessionStorage.removeItem(mileageKey);
  };

  const validateMileage = (enteredOrSavedMileage) => {
    if (!saleMileage) return MileageError.UNKNOWN;

    const savedNumberValue = parseInt((enteredOrSavedMileage || '').replace(/[,$]/g, ''), 10);

    if (savedNumberValue < saleMileage) return MileageError.TOO_LOW;

    const daysSinceSale = Math.max(daysSince(saleEffectiveDate), 1);
    const estimatedMaxMiles = saleMileage + daysSinceSale * 100;

    if (savedNumberValue > estimatedMaxMiles) return MileageError.TOO_HIGH;

    return false;
  };

  useEffect(() => {
    if (vehicleId) {
      getMileageFromStorage();
    }
  }, [vehicleId]);

  return {
    savedMileage,
    saveMileage,
    deleteSavedMileage,
    validateMileage,
  };
};

export default useMileage;
